import { primitiveTokens, semanticThemeTokens } from "@appretio/ui-kit";
import { style } from "@vanilla-extract/css";

export const formContainer = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["4x"],
  paddingTop: primitiveTokens.sizing["2x"]
});

export const formField = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["1x"]
});

export const toggleList = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["2x"]
});

export const formErrorText = style({
  color: semanticThemeTokens.input.invalid.borderColor,
  fontSize: primitiveTokens.type.xs,
  paddingTop: primitiveTokens.sizing["1x"]
});
